export default{
  tableOfContent:{
    layers:'Couches',
    baseLayers:'Fond cartographique',
    baseLayersNone:'Aucun fond cartographique'
  }
}